Ready(() => {
  [].forEach.call(document.querySelectorAll('td[data-link], tr[data-link], th[data-link]'), function(el) {
    el.addEventListener('click', function(e) {
      if (el.getAttribute('data-bs-modal')) return true
      if (e.target.nodeName == 'A' || e.target.nodeName == 'I') return true
      if (typeof(Turbolinks) == 'undefined' || !Turbolinks.supported) {
        window.location = el.getAttribute('data-link')
      } else {
        Turbolinks.visit(el.getAttribute('data-link'))
      }
    })
  })
});
// used in eRostering and Foundry, not sure about Sard